export default "__VITE_ASSET__CxFAbOiJ__"